import React from 'react';
import './css/Become.css';

function BecomeText() {
  return (
    <div className="become_text">
      <b>Become a model</b>
      <br />
      <br />
      Diva Models is always interested in representing new models, but before you contact us, you should read the following.
      <br />
      <br />
      First and foremost we represent young models with international potential. Girls can begin modelling in their early teenage years, boys can begin around their 17th year. Our models work all over the world with Diva Models as their base. With the proper planning and the right attitude it is possible for most young people to combine a model career with studies. Later on one can consider the possibility of working full time.
      <br />
      Diva Models also represent men and women ranging from their mid twenties to mid fifties. Most of the models from this division are very experienced. Please note that this is not a "must" to begin a modeling career as an adult.
      <br />
      <br />
      Beside our own models we represent many foreign models from agencies all over the world.
      <br />
      <br />
      <b>What are the requirements at Diva Models to be considered as a model?</b>
      <br />
      <br />
      It is required that females are minimum 172 cm and males at least 182cm.
      <br />
      You do not have to look in a certain way, which makes it difficult to define exactly what we are looking for. A good physical appearance, beautiful skin, interesting characteristics, and not to forget the drive and the believe in that you can become a good model.
      <br />
      <br />
      <a href={`mailto:divamodels@divamodels.com?body=${encodedText}`}>Submit here</a>
    </div>
  );
}

const text = "---PLEASE FILL OUT THE FOLLOWING---\n\
Name: \n\
Last name: \n\
Birthday: \n\
Email: \n\
Phone: \n\
Address: \n\
Zip code: \n\
City: \n\
Country: \n\n\
---PLEASE WRITE MEASUREMENTS IN CM ---\n\
Height: \n\
Bust/chest: \n\
Waist: \n\
Hips: \n\
Shoes: \n\
Eye: \n\
Hair: \n\
Occupation: \n\n\
---PLEASE ATTACH IMAGES BELOW---\
"

const encodedText = encodeURIComponent(text)
export default () => (
  <div className="become">
    <BecomeText />
  </div>
);
